import { FC } from 'react';

const PerformanceIcon: FC<{
  fill?: string;
  height?: number;
  width?: number;
}> = ({ fill = '#3C3F43', height = 16, width = 16 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33333 3H0.666667C0.489856 3 0.320286 3.07024 0.195262 3.19526C0.0702379 3.32029 0 3.48986 0 3.66667L0 8.33333C0 8.51014 0.0702379 8.67971 0.195262 8.80474C0.320286 8.92976 0.489856 9 0.666667 9H1.33333C1.42174 9 1.50652 8.96488 1.56904 8.90237C1.63155 8.83986 1.66667 8.75507 1.66667 8.66667V3.33333C1.66667 3.24493 1.63155 3.16014 1.56904 3.09763C1.50652 3.03512 1.42174 3 1.33333 3Z"
        fill={fill}
      />
      <path
        d="M4.66683 1.66699H3.00016C2.82335 1.66699 2.65378 1.73723 2.52876 1.86225C2.40373 1.98728 2.3335 2.15685 2.3335 2.33366V9.66699C2.3335 9.8438 2.40373 10.0134 2.52876 10.1384C2.65378 10.2634 2.82335 10.3337 3.00016 10.3337H4.66683C4.7106 10.3337 4.75395 10.325 4.79439 10.3083C4.83483 10.2915 4.87158 10.267 4.90253 10.236C4.93348 10.2051 4.95804 10.1683 4.97479 10.1279C4.99154 10.0874 5.00016 10.0441 5.00016 10.0003V2.00033C5.00016 1.91192 4.96504 1.82714 4.90253 1.76462C4.84002 1.70211 4.75523 1.66699 4.66683 1.66699Z"
        fill={fill}
      />
      <path
        d="M15.3335 3H14.6668C14.5784 3 14.4936 3.03512 14.4311 3.09763C14.3686 3.16014 14.3335 3.24493 14.3335 3.33333V8.66667C14.3335 8.75507 14.3686 8.83986 14.4311 8.90237C14.4936 8.96488 14.5784 9 14.6668 9H15.3335C15.5103 9 15.6799 8.92976 15.8049 8.80474C15.9299 8.67971 16.0002 8.51014 16.0002 8.33333V3.66667C16.0002 3.48986 15.9299 3.32029 15.8049 3.19526C15.6799 3.07024 15.5103 3 15.3335 3Z"
        fill={fill}
      />
      <path
        d="M13 1.66699H11.3333C11.2449 1.66699 11.1601 1.70211 11.0976 1.76462C11.0351 1.82714 11 1.91192 11 2.00033V10.0003C11 10.0887 11.0351 10.1735 11.0976 10.236C11.1601 10.2985 11.2449 10.3337 11.3333 10.3337H13C13.1768 10.3337 13.3464 10.2634 13.4714 10.1384C13.5964 10.0134 13.6667 9.8438 13.6667 9.66699V2.33366C13.6667 2.15685 13.5964 1.98728 13.4714 1.86225C13.3464 1.73723 13.1768 1.66699 13 1.66699Z"
        fill={fill}
      />
      <path
        d="M5.99984 5H9.99984C9.99984 5 10.3332 5 10.3332 5.33333V6.66667C10.3332 6.66667 10.3332 7 9.99984 7H5.99984C5.99984 7 5.6665 7 5.6665 6.66667V5.33333C5.6665 5.33333 5.6665 5 5.99984 5Z"
        fill={fill}
      />
      <path
        d="M11.6665 6.83301C12.6224 6.83301 13.5572 7.11641 14.3521 7.64746C15.1468 8.17854 15.7665 8.93328 16.1323 9.81641C16.4982 10.6996 16.5942 11.6718 16.4077 12.6094C16.2212 13.547 15.7604 14.4081 15.0845 15.084C14.4086 15.7599 13.5475 16.2207 12.6099 16.4072C11.6723 16.5937 10.7001 16.4977 9.81689 16.1318C8.93377 15.766 8.17903 15.1463 7.64795 14.3516C7.1169 13.5567 6.8335 12.6219 6.8335 11.666L6.83936 11.4258C6.90033 10.2321 7.4023 9.10014 8.25146 8.25098C9.15731 7.34513 10.3854 6.83494 11.6665 6.83301ZM10.6431 11.1533H10.9673C11.0995 11.1534 11.2278 11.1923 11.3364 11.2646L11.438 11.3486L11.522 11.4502C11.5943 11.5588 11.6332 11.6872 11.6333 11.8193C11.6334 11.643 11.7037 11.4737 11.8286 11.3486L11.9302 11.2646C12.039 11.1921 12.1678 11.1533 12.3003 11.1533H12.6235L11.6333 9.91406L10.6431 11.1533Z"
        fill={fill}
        stroke="white"
      />
    </svg>
  );
};

export default PerformanceIcon;
